export default {
    CHANGE_LOADER(state, loader){
        state.loader = loader
    }
}
